import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    wxId: null,
    zlbUserId: null,
    raxwId: null
  },
  mutations: {
    setWxId(state, val) {
      state.wxId = val;
    },
    setZlbUserId(state, val) {
      state.zlbUserId = val;
    },
    setRaxwId(state, val) {
      state.raxwId = val;
    }
  },
  actions: {},
  modules: {},
  getters: {
    getWxId: (state) => state.wxId,
    getZlbUserId: (state) => state.zlbUserId,
    getRaxwId: (state) => state.raxwId
  }
});
